import _ from 'lodash'

// Redux-form document
// https://redux-form.com/8.1.0/docs/gettingstarted.md/

/**
 * redux-form field input methods
 * 改變欄位內容
 *
 * @see https://redux-form.com/8.1.0/docs/api/field.md/#-code-input-onblur-eventorvalue-function-code-
 */
export const changeAndBlurInput = (field, targetValue) => {
  const {
    input: {
      onChange,
      onBlur
    }
  } = field

  onChange(targetValue)
  onBlur(targetValue)
}

/**
 * @param {Object} field It's what the redux-form Field will pass to the wrapped component.
 * @returns
 * @see https://redux-form.com/8.1.0/docs/api/field.md/#props
 */
export const getInputValue = field => {
  const inputValue = _.get(field, 'input.value', '')
  return inputValue
}
